import { render } from "./ThemeConfigs.vue?vue&type=template&id=fbf6f27c&scoped=true"
import script from "./ThemeConfigs.vue?vue&type=script&lang=js"
export * from "./ThemeConfigs.vue?vue&type=script&lang=js"

import "./ThemeConfigs.vue?vue&type=style&index=0&id=fbf6f27c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbf6f27c"]])

export default __exports__